<div ref="qList" class="tt-c-questions">
  <tt-user-toolbar v-if="qaConfig.displayUserToolbar"></tt-user-toolbar>
  <div v-if="totalWithComments > 0" class="tt-c-questions__toolbar tt-c-toolbar">
    <div class="tt-c-toolbar__content-left">
      <span ref="total" class="tt-c-questions__total" role="heading" :aria-level="qaConfig.headingLevel" tabindex="-1" v-html="$msg('qa.questionCount', [formattedTotal], totalWithComments)"></span>
      <tt-menu v-if="showSort" ref="sortByMenu" :tiggerAriaLabel="$msg('qa.sortQuestions')" triggerClass="tt-c-questions__sort" triggerType="toolbar">
        <template v-slot:triggerContent>
          <span class="tt-c-questions__sort-text" v-html="sortByTitle"></span>
          <tt-icon size="xxs" name="arrow-fill"></tt-icon>
        </template>
        <tt-menu-list ref="sortByMenuList" :menuItems="sortOptions" @menuItemSelected="sortOrderSelected" type="dropdown"></tt-menu-list>
      </tt-menu>
    </div>
  </div>

  <div class="tt-c-questions__list">
    <tt-comments-question @commentsLoaded="commentsLoaded" v-if="qaConfig.showCheckoutChatterOnQAWidget"></tt-comments-question>
    <template v-if="showBasicQuestions">
      <tt-basic-question v-for="question in questions" :question="question" :key="question.id"></tt-basic-question>
    </template>
    <template v-if="showFullQuestion">
      <tt-question v-for="question in questions"
                  :isRelated="currentSku.toLowerCase() !== question.catItem.sku.toLowerCase()"
                  :question="question"
                  :key="question.id"
                  :showBestAnswer="!qaConfig.hideBestAnswer"
                  @showError="onShowError"></tt-question>
    </template>
  </div>
  <div v-if="useShowMore" class="tt-c-questions__list-show-more">
    <div v-show="showMoreDisabled" class="tt-o-spinner"></div>
    <tt-button v-show="!showMoreDisabled && hasMore" @click="showMore" type="primary" class="tt-c-questions__list-show-more-btn" v-html="$msg('qa.showMore')"></tt-button>
  </div>
  <tt-pagination v-else-if="!useShowMore"
                 :currentPage="currentPage"
                 @updatePage="pageChange"
                 :contentType="$msg('qa.paginationType')"
                 :total="total"
                 :initialPageSize="qaConfig.initialPageSize"
                 :pageSize="qaConfig.pageSize"></tt-pagination>

  <tt-related-questions-list v-if="showRelatedList" :showFullQuestion="showFullQuestion"></tt-related-questions-list>

</div>
